// extracted by mini-css-extract-plugin
module.exports = {"addCategoryScreen":"EditVendorScreen_addCategoryScreen__14sKt","addCategoryHeading":"EditVendorScreen_addCategoryHeading__1QZxj"};